import { Navigate } from 'react-router-dom';
import { checkPermissions } from '../helpers/checkPermissionHelper';
import { AppRoutes } from '../constants/appRoutes';

export const RoutePermission = ({ authKey, authMultiKeys = [], children }) => {
	if (!checkPermissions(authKey, authMultiKeys)) {
		return <Navigate to={`/${AppRoutes.Unauthorized}`}></Navigate>;
	}

	return children;
};
